<template>
  <div>
    <HeaderInstaller
      :arrow="true"
      :title="'Aplicadores - ' + this.$route.query.profile"
      @voltar="voltarInstallers()"
      :haveAction="false"
    />

    <v-container style="max-width: unset" class="px-8">
      <v-card
        class="main-card pa-3"
        transition="scale-transition"
        elevation="0"
      >
        <v-row class="ma-0">
          <v-col
            style="color: black; text-align: -webkit-center"
            cols="12"
            md="3"
            sm="2"
          >
            <v-img
              :src="
                currentInstaller.image != null
                  ? env_url + currentInstaller.image
                  : ''
              "
              :alt="'profilePicture'"
              style="border-radius: 20px; background-color: #ccc"
              class="imgInstaller"
              height="150"
              max-width="190"
            >
              <strong
                class="main-subtitle"
                v-if="currentInstaller.image != null"
              >
                Imprimax
              </strong>
            </v-img>
          </v-col>

          <v-col
            class="d-flex flex-column justify-space-around"
            cols="12"
            md="3"
            sm="2"
          >
            <div>
              <h3 class="main-title">
                {{ this.currentInstaller.name }}
              </h3>
              <h3 class="main-subtitle">
                {{ this.currentInstaller.neighborhood }},
                {{ this.currentInstaller.city }}
              </h3>
            </div>

            <div>
              <strong>Cadastro:</strong>
              <span class="px-1">
                {{ formatDate(this.currentInstaller.created_at) }}
              </span>
              <br />
              <strong>Ultimo Acesso:</strong>
              <span class="px-1">
                {{ formatDate(this.currentInstaller.last_sign) }}
              </span>
            </div>
          </v-col>

          <v-col style="color: black" cols="12" md="3" sm="2">
            <v-row class="pa-2" style="width: 80%">
              <v-select
                hide-details
                outlined
                class="secondary-input"
                style="max-width: 120px"
                v-model="currentInstaller.status"
                label="Status"
                :items="status"
                item-text="label"
                @change="toggleChangeDialog"
                item-value="value"
                :rules="[(v) => !!v || 'Tipo requerido']"
                required
              ></v-select>
            </v-row>

            <div class="d-flex align-center">
              <v-icon
                large
                @click="toogle"
                :color="active ? '#C4C4C4' : 'normalred'"
              >
                {{ active ? "mdi-star-outline" : "mdi-star" }}
              </v-icon>

              <span
                style="
                  font-family: Gothic A1;
                  font-style: normal;
                  font-weight: bold;
                  font-size: 16px;
                  line-height: 22px;

                  color: #9c9c9c;
                "
                >{{ active ? "Favoritar" : "Favorito" }}</span
              >
            </div>
          </v-col>

          <div class="p-2"></div>
        </v-row>
      </v-card>

      <v-tabs
        class="px-3"
        background-color="#ECEEF1"
        grow
        height="55"
        hide-slider
      >
        <v-tab
          active-class="active-tab"
          class="tab"
          style="font-weight: bold !important"
          href="#mobile-tabs-5-1"
          @click="activeTab = 0"
        >
          <span>Histórico de aplicações</span>
        </v-tab>

        <v-tab active-class="active-tab" class="tab" @click="activeTab = 1">
          <span>Especialidades</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab" style="border-radius: 6px">
        <v-tab-item :value="0" class="pb-4">
          <!-- Filtro Tab 0 -->
          <v-row class="pt-3 pr-6 pl-9 pb-2">
            <v-col
              class="d-flex flex-column align-start my-1 py-1"
              cols="12"
              lg="4"
              md="4"
              sm="6"
            >
              <v-autocomplete
                v-model="filter.Specialties"
                class="secondary-input"
                style="width: 100%"
                attach
                outlined
                required
                @change="filterTable"
                :loading="loading"
                :items="specialtiesArray"
                item-text="name"
                item-value="value"
                color="#ccc"
                placeholder="Especialidade"
                hide-details
                append-icon="mdi-chevron-down"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-data-table
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhuma aplicação encontrada para este aplicador"
            :headers="headers"
            :items="installers"
            class="elevation-0 content-table"
            hide-default-footer
            :items-per-page="pageSize"
            :header-props="headerProps"
            :key="componentKey"
          >
          </v-data-table>
        </v-tab-item>

        <v-tab-item :value="1" class="pb-4">
          <!-- Filtro Tab 1 -->
          <v-row class="pt-3 pr-6 pl-9 pb-2">
            <v-col
              class="d-flex flex-column align-start my-1 py-1"
              cols="12"
              lg="2"
              md="2"
              sm="6"
            >
              <v-autocomplete
                v-model="filter.order"
                class="secondary-input"
                attach
                color="secondary"
                outlined
                style="width: 100%"
                :items="orders"
                item-text="label"
                item-value="value"
                required
                label="Ordem"
                @change="filterTable"
                hide-details
                :loading="loading"
                append-icon="mdi-chevron-down"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex flex-column align-start my-1 py-1"
              cols="12"
              lg="3"
              md="3"
              sm="6"
            >
              <v-autocomplete
                v-model="filter.all"
                class="secondary-input"
                attach
                outlined
                style="width: 100%"
                :items="exibedAll"
                item-text="label"
                item-value="value"
                required
                label="Exibir Todas"
                @change="filterTable"
                hide-details
                append-icon="mdi-chevron-down"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-data-table
            id="product-profile-table"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhuma especialidade encontrada para este aplicador"
            :headers="headers2"
            :items="specialtiesArray"
            class="elevation-0"
            hide-default-footer
            :items-per-page="pageSize"
            :header-props="headerProps"
            :key="componentKey"
          >
            <template v-slot:[`item.checked`]="{ item }">
              <span>
                {{ isSpecialist(item) }}
              </span>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItems > pageSize"
                    :currentPage="currentPage"
                    :totalItems="totalItems"
                    :page="page"
                    :pageSize="pageSize"
                    :totalPages="totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>

    <v-dialog v-model="changeDialog" max-width="450px">
      <AprovalModal
        :title="
          this.currentInstaller.status == 1
            ? 'Ativar Aplicador'
            : 'Inativar Aplicador'
        "
        textMessage="Tem certeza que deseja alterar este status?"
        cancelBtn="Cancelar"
        :okbtn="currentInstaller.status == 1 ? 'INATIVAR' : 'ATIVAR'"
        textObservation=""
        icone="mdi-restore-alert"
        @close="changeDialog = false"
        @action="changeStatus"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.imgInstaller {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-card {
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1) !important;
  border-radius: 6px !important;
}

.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}
.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.main-title {
  font-weight: bold;
  font-size: 30px;
  line-height: 35px;

  color: #000000;
}

.main-subtitle {
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #5f6368;
}

.date-title {
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #333333;
}

.labelR {
  font-family: Gothic A1;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: #bc0000;
}

.date {
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #333333;
}

.labelR2 {
  font-family: Gothic A1;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 30px;
  text-align: center;

  color: #2d3038;
}

p {
  font-weight: bold;
}

.flex-end {
  justify-content: flex-end;
}

.black--text /deep/ label {
  color: black;
  font-size: 13px;
}

.table-button {
  font-weight: bold !important;
  transition: 300ms !important;
}

.table-button:hover {
  background: #2d3038 !important ;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Utils from "../../../../Utils/FormatDate";
import AprovalModal from "../../components/AprovalModal.vue";
import HeaderInstaller from "../components/HeaderInstaller.vue";
import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "Register",

  props: {
    installers: Object,
  },

  components: {
    Pagination,
    HeaderInstaller,
    AprovalModal,
  },

  async created() {
    this.env_url = process.env.VUE_APP_BASE_URL;
    await this.updateSpecialties();
    await this.updateInstaller();
    this.active = !this.currentInstaller.isFavorite;
  },

  data: () => ({
    activeTab: 0,
    changeDialog: false,
    specialties: [],
    specialtiesArray: [],
    orders: [
      { label: "Alfabética", value: 0 },
      { label: "Data de Aplicação", value: 1 },
    ],
    rating: 3.8,
    title: "",

    exibedAll: [
      { label: "Todos", value: true },
      { label: "Somente Especialista", value: false },
    ],
    componentKey: false,
    active: false,
    selected: [],
    status: [
      { label: "Ativo", value: 1 },
      { label: "Inativo", value: 0 },
    ],
    headers: [
      {
        text: "Data",
        align: "center",
        class: "item",
        value: "salesDate",
        sortable: false,
      },

      {
        text: "Cliente",
        class: "item",
        align: "center",
        value: "installers.email",
        sortable: false,
      },
      {
        text: "SKU",
        class: "item",
        align: "center",
        value: "installers.Id",
      },

      {
        text: "Especialidade",
        class: "item",
        align: "center",
        value: "installers.name",
        sortable: false,
      },
      {
        text: "QTD",
        class: "item",
        align: "center",
        value: "installers.price",
      },
    ],
    headers2: [
      {
        text: "Especialidade",
        class: "item",
        align: "center",
        value: "name",
      },
      {
        text: "Número de aplicações",
        class: "item",
        align: "center",
        value: "installers.name",
        sortable: false,
      },
      {
        text: "É especialista?",
        class: "item",
        align: "center",
        value: "checked",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    dialogKey: false,
    filter: {
      all: false,
      page: 1,
      pageSize: 15,
    },
    valid: true,
    dialog: false,
    loading: false,
    isEditing: false,
    installerId: "",
    sucessDialog: false,
    firstValid: true,
    closeNoLoading: false,
    apiService: new ApiService(),
    page: 1,
    totalPages: 1,
    pageSize: 15,
    totalItems: 15,
    currentPage: 15,
    currentInstaller: {},
    files: [],
    rules: {
      required: (value) => !!value || "Campo requerido.",
    },
  }),

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },

  methods: {
    async changeStatus() {
      this.loading = true;

      await this.apiService
        .post(`installer/changestatus`, this.currentInstaller)
        .then((resp) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Mudança de status efetuada!",
            message: "Mudança de status efetuada!",
            trace: null,
          });
          this.changeDialog = false;
        })
        .catch((err) => {
          if (err.status != 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível mudar a status do aplicador",
              message: "Confira se o e-mail já está cadastrado",
              trace: null,
            });
          } else if (err.status == 403) {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Este usuário não tem autorização para concluir a ação.",
              message: "Somente usuários com permissão podem deletar/editar",
              trace: null,
            });
          }

          this.loading = false;
        });
    },

    toggleChangeDialog() {
      this.dialogKey = !this.dialogKey;
      this.changeDialog = true;
    },

    isSpecialist(v) {
      let response;
      let find = this.currentInstaller.specialties.find(
        (y) => y.specialtiesId == v.id
      );

      if (find) {
        response = "Sim";
      } else {
        response = "Não";
      }
      return response;
    },

    formatDate(date) {
      return Utils.moment(date);
    },

    changeFavorite() {
      this.loading = true;

      this.currentInstaller.isFavorite = !this.active;

      this.apiService
        .post("installer/changefavorite", this.currentInstaller)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    toogle() {
      this.active = !this.active;
      this.changeFavorite();
    },

    back() {
      this.$router.push("/installers");
    },

    toLogin() {
      this.$router.push("/");
    },

    userSaved(message) {
      this.$emit("show", message);
    },

    save(date) {
      this.$refs.menu.save(date);
    },

    close() {
      this.$emit("close");
    },

    voltarInstallers() {
      this.$router.push("/installers");
    },

    async filterTable() {
      this.loading = false;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
      await this.updateSpecialties();
    },

    async backPage() {
      this.page -= 1;
      this.filter.page = this.page;
      await this.updateSpecialties();
    },

    async nextPage() {
      this.page += 1;
      this.filter.page = this.page;
      await this.updateSpecialties();
    },


    async updateSpecialties() {
      this.loading = true;
      this.isLoading = true;
      this.filter.installerId = this.$route.query.id;
      await this.apiService
        .post(`specialties/listbyinstaller`, this.filter)
        .then((response) => {
          this.totalPages = response.pager.totalPages;
          this.currentPage = response.pager.currentPage;
          this.totalItems = response.pager.totalItems;
          this.specialtiesArray = response.specialties;
          this.loading = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.close();
        });
    },

    async updateInstaller() {
      this.loading = true;
      this.installerId = this.$route.query.id;

      await this.apiService
        .get(`installer/getprofile?id=` + this.installerId)
        .then((response) => {
          this.currentInstaller = response;
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao encontrar este aplicador ",
            message: err.body.message,
            trace: null,
          });

          this.loading = false;
        });
    },
  },
};
</script>
